import React from "react";
import { Text, View, StyleSheet } from "@react-pdf/renderer";
import { AssignmentResult } from "../../../../api/types";
import { DedupedActivities } from "./DedupedActivities";

export const AppendixStyle = StyleSheet.create({
	container: {
		position: "absolute",
		top: 120,
		paddingHorizontal: 50,
		flexDirection: "column",
	},
	title: {
		fontFamily: "Inter",
		fontStyle: "normal",
		fontWeight: "bold",
		fontSize: 32,
		marginBottom: 42,
	},
	asgmtContainer: {
		flexDirection: "column",
		marginBottom: 40,
		alignItems: "flex-start",
	},
	asgmtName: {
		fontFamily: "Inter",
		fontStyle: "normal",
		fontWeight: "semibold",
		fontSize: 20,
	},
	activityContainer: {
		flexDirection: "column",
		width: 674,
	},
	activityRow: {
		flexDirection: "row",
		width: 674,
	},
	activityEntry: {
		flexDirection: "column",
	},
	image: {
		width: 170,
		height: 100,
		marginRight: 31,
		marginDown: 8,
	},
	imgCaption: {
		fontFamily: "Inter",
		fontStyle: "normal",
		fontSize: 13,
		width: 170,
		alignSelf: "center",
	},
});

interface AppendixContentProps {
	data: AssignmentResult[];
}

export const AppendixContent: React.FC<AppendixContentProps> = ({
	data,
}): JSX.Element => (
	<View style={AppendixStyle.container}>
		<Text style={AppendixStyle.title}>Appendix</Text>
		{data &&
			data.map((asgmtRes, i) => (
				<View key={i} style={AppendixStyle.asgmtContainer}>
					<Text style={AppendixStyle.asgmtName}>
						{asgmtRes.assignmentDetails.name}
					</Text>
					<DedupedActivities
						activities={asgmtRes.assignmentDetails.activities}
					/>
				</View>
			))}
	</View>
);
